import { render, staticRenderFns } from "./NewCliSuc.vue?vue&type=template&id=92885cdc&"
import script from "./NewCliSuc.vue?vue&type=script&lang=js&"
export * from "./NewCliSuc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports